const PERF_FLAG_KEY = 'ml_perf';

export const perfNow = () => {
  if (typeof performance !== 'undefined' && performance.now) {
    return performance.now();
  }
  return Date.now();
};

export const isPerfEnabled = () => {
  if (import.meta?.env?.DEV) return true;
  if (typeof sessionStorage === 'undefined') return false;
  return sessionStorage.getItem(PERF_FLAG_KEY) === '1';
};

export const logPerf = (label, durationMs, details = {}) => {
  if (!isPerfEnabled()) return;
  const rounded = Math.round(durationMs);
  let message = `[perf] ${label} ms=${rounded}`;
  if (details.endpoint) {
    message += ` endpoint=${details.endpoint}`;
  }
  if (details.status) {
    message += ` status=${details.status}`;
  }
  console.info(message);
};
